import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import {
    MatDialogActions, MatDialogClose,
    MatDialogContent,
    MatDialogRef, MatDialogTitle,
} from '@angular/material/dialog';

import { FsAutocompleteChipsModule } from '@firestitch/autocomplete-chips';
import { FsDialogModule } from '@firestitch/dialog';
import { FsFormModule } from '@firestitch/form';

import { Subject, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AclService } from '@app/core';
import { EnvironmentData } from '@common/data';
import { Organization } from '@common/interfaces';


@Component({
  templateUrl: './converstation-start.component.html',
  styleUrls: ['./converstation-start.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    FsFormModule,
    FsDialogModule,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FsAutocompleteChipsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ConversationStartComponent implements OnDestroy {
  private _dialogRef = inject<MatDialogRef<ConversationStartComponent>>(MatDialogRef);
  private _environmentData = inject(EnvironmentData);
  private _aclService = inject(AclService);


  public organization: Organization = null;

  private _destroy$ = new Subject();

  public fetchOrganizations = (keyword: string) => {
    const query: any = {
      keyword,
      limit: 30,
    };

    if (!this._aclService.hasPermissionAdmin()) {
      query.enableConversations = true;
    }

    return this._environmentData
      .gets(query);
  };

  public save = () => {
    return of(this.organization)
      .pipe(
        tap((organization) => this._dialogRef.close(organization)),
      );
  };

  public ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

}
